import { render, staticRenderFns } from "./DispensationCheckForm.vue?vue&type=template&id=72c1d93d&scoped=true&"
import script from "./DispensationCheckForm.vue?vue&type=script&lang=ts&"
export * from "./DispensationCheckForm.vue?vue&type=script&lang=ts&"
import style0 from "./DispensationCheckForm.vue?vue&type=style&index=0&id=72c1d93d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c1d93d",
  null
  
)

export default component.exports